<div class="match">
  <div class="match__hero">
    <mat-icon class="match__icon" aria-hidden="true">favorite</mat-icon>
    <h2 class="match__title">You’re a 100% match</h2>
    <p class="match__lead">
      Our proprietary algorithm and destiny both agree: you belong in Gage’s DMs.
    </p>
  </div>

  <div class="match__actions">
    <button mat-flat-button color="primary" type="button" (click)="openChatWithGage()">
      <mat-icon aria-hidden="true">chat</mat-icon>
      Open chat with Gage
    </button>
    <button mat-button type="button" (click)="dismiss()">Not now</button>
  </div>
</div>
